import { createSelector, createStructuredSelector } from 'reselect';
import memoize from 'lodash.memoize';

export default function resourceListSelectorFactory(getAllOfResource, rootApi) {
  return function (selector, api, config) {
    return createSelector(selector, getAllOfResource, function (s) {
      return s;
    }, function (list, allResources, state) {
      return list.map(function (idOrResource) {
        return rootApi(function () {
          return typeof idOrResource === 'string' ? allResources[idOrResource] : idOrResource;
        }, api, config)(state);
      });
    });
  };
}